import Card from "./Card";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import apiService from "../services/api";
import { Button } from "./ui/Button";
import { Notification, Status } from "./ui/Notification";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<Status>({ type: "idle" });

  const handleRequestReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "idle" });

    try {
      const response = await apiService.requestPasswordReset(email);
      setStatus({
        type: "success",
        message:
          response.message ||
          "Password reset email sent. Please check your email.",
      });
    } catch (err) {
      setStatus({
        type: "error",
        message:
          err instanceof Error ? err.message : "Failed to send reset email",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-letterboxd-bg-primary flex justify-center mt-20 px-4">
      <div className="w-full max-w-md">
        <h2 className="type-h1 text-letterboxd-text-primary mb-6 text-center">
          Reset your password
        </h2>
        <p className="text-letterboxd-text-secondary text-center">
          Enter your email to receive a reset link
        </p>

        <Card>
          <form onSubmit={handleRequestReset} className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block type-body-strong text-letterboxd-text-secondary mb-2"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                className="input-field w-full"
                placeholder="Enter your email"
              />
            </div>

            <Notification status={status} />

            <Button type="submit" loading={loading} className="w-full mt-6">
              Send Reset Email
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to={"/login"}>Back to login</Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
